import { render, staticRenderFns } from "./filename.vue?vue&type=template&id=5c5f258e&scoped=true"
import script from "./filename.vue?vue&type=script&lang=js"
export * from "./filename.vue?vue&type=script&lang=js"
import style0 from "./filename.vue?vue&type=style&index=0&id=5c5f258e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f258e",
  null
  
)

export default component.exports